import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  ChevronDownIcon,
  EnvelopeIcon,
  ChatBubbleLeftRightIcon,
  QuestionMarkCircleIcon,
  TruckIcon,
  CreditCardIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';
import Header from './app/Header';
import Footer from './app/Footer';
import FooterCopyright from './app/FooterCopyright';
import { FAQS, CONTACT_EMAIL, SHARED, whatsappHref, defaultWhatsappMessage } from './utils/product';

const categorias = [
  { icon: QuestionMarkCircleIcon, title: 'Como começar', desc: 'Assinar Diário, Semanal ou Mensal.' },
  { icon: TruckIcon, title: 'Sobre as rotas', desc: 'SLA, 15 minutos na porta e cobertura.' },
  { icon: CreditCardIcon, title: 'Planos', desc: 'Paradas inclusas e extras por parada.' },
  { icon: ShieldCheckIcon, title: 'Pacotes', desc: 'Limite 40×40×40 cm e 8 kg.' },
];

const Ajuda = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const wpp = whatsappHref(defaultWhatsappMessage);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 bg-mesh-light" aria-hidden="true" />
        <div className="relative container mx-auto px-4 lg:px-6 py-16 lg:py-24 text-center">
          <span className="badge-brand mb-5">Central de ajuda</span>
          <h1 className="font-display text-display-xl text-ink-900">
            Como podemos ajudar?
          </h1>
          <p className="mt-5 text-xl text-ink-500 max-w-xl mx-auto">
            Respostas sobre rotas Fretz Empresas na {SHARED.coverage}.
          </p>
        </div>
      </section>

      <section className="section-tight bg-ink-50">
        <div className="container mx-auto px-4 lg:px-6">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {categorias.map(({ icon: Icon, title, desc }) => (
              <a key={title} href="#faq" className="card p-6 hover:-translate-y-1 transition-transform">
                <div className="h-12 w-12 rounded-2xl bg-brand-50 text-brand-700 flex items-center justify-center">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="font-display font-bold text-ink-900 mt-4">{title}</h3>
                <p className="text-ink-500 text-sm mt-1">{desc}</p>
              </a>
            ))}
          </div>
        </div>
      </section>

      <section id="faq" className="section bg-white">
        <div className="container mx-auto px-4 lg:px-6 max-w-3xl">
          <div className="text-center mb-12">
            <p className="eyebrow mb-2">Perguntas frequentes</p>
            <h2 className="font-display text-display-lg text-ink-900">FAQ</h2>
          </div>

          <div className="space-y-3">
            {FAQS.map((item, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div key={item.q} className="card overflow-hidden">
                  <button
                    onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                    className="w-full flex items-center justify-between gap-4 p-5 lg:p-6 text-left hover:bg-ink-50 transition"
                    aria-expanded={isOpen}
                  >
                    <span className="font-display font-bold text-ink-900 text-lg">{item.q}</span>
                    <ChevronDownIcon
                      className={`h-5 w-5 text-ink-500 shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                    />
                  </button>
                  {isOpen && (
                    <div className="px-5 lg:px-6 pb-5 lg:pb-6 text-ink-600 leading-relaxed fade-up">
                      {item.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section id="contato" className="section bg-ink-50">
        <div className="container mx-auto px-4 lg:px-6">
          <div className="text-center mb-10">
            <p className="eyebrow mb-2">Não achou o que precisava?</p>
            <h2 className="font-display text-display-lg text-ink-900">Fale com a gente</h2>
          </div>
          <div className="grid sm:grid-cols-2 gap-4 max-w-xl mx-auto">
            <a href={`mailto:${CONTACT_EMAIL}`} className="card p-6 text-center hover:-translate-y-1 transition-transform">
              <div className="h-12 w-12 rounded-2xl bg-brand-gradient text-white flex items-center justify-center shadow-glow mx-auto">
                <EnvelopeIcon className="h-6 w-6" />
              </div>
              <p className="font-bold text-ink-900 mt-4">E-mail</p>
              <p className="text-sm text-ink-500 mt-1">{CONTACT_EMAIL}</p>
            </a>
            {wpp ? (
              <a href={wpp} className="card p-6 text-center hover:-translate-y-1 transition-transform">
                <div className="h-12 w-12 rounded-2xl bg-brand-gradient text-white flex items-center justify-center shadow-glow mx-auto">
                  <ChatBubbleLeftRightIcon className="h-6 w-6" />
                </div>
                <p className="font-bold text-ink-900 mt-4">WhatsApp</p>
                <p className="text-sm text-ink-500 mt-1">Falar agora</p>
              </a>
            ) : (
              <Link to="/#contato" className="card p-6 text-center hover:-translate-y-1 transition-transform">
                <div className="h-12 w-12 rounded-2xl bg-brand-gradient text-white flex items-center justify-center shadow-glow mx-auto">
                  <ChatBubbleLeftRightIcon className="h-6 w-6" />
                </div>
                <p className="font-bold text-ink-900 mt-4">Formulário</p>
                <p className="text-sm text-ink-500 mt-1">Quero Fretz Empresas</p>
              </Link>
            )}
          </div>
          <div className="text-center mt-10">
            <Link to="/" className="btn-primary">Voltar para a home</Link>
          </div>
        </div>
      </section>

      <Footer />
      <FooterCopyright />
    </div>
  );
};

export default Ajuda;
